import { Link } from 'react-router-dom';
import { ArrowUpRight, Feather } from 'lucide-react';
import { POSTS } from '@/data/posts';
import { HOME } from '@/constants/testIds';

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });

export default function FieldNotes() {
  const featured = POSTS.slice(0, 3);

  return (
    <section
      id="field-notes"
      data-testid={HOME.fieldNotesSection}
      className="section bg-[var(--brand-parchment-warm)] relative"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <span className="font-eyebrow inline-flex items-center gap-2">
              <Feather size={12} strokeWidth={1.8} /> Field Notes
            </span>
            <h2 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl text-[var(--brand-forest)] leading-[1.02] tracking-tight">
              Stories from the beat.<br />
              <span className="italic">Routes worth taking.</span>
            </h2>
          </div>
          <Link
            to="/field-notes"
            data-testid={HOME.fieldNotesReadAll}
            className="link-expand text-sm font-semibold text-[var(--brand-forest)] inline-flex items-center gap-1.5 self-start lg:self-end"
          >
            Read all field notes <ArrowUpRight size={14} />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((p) => (
            <Link
              to={`/field-notes/${p.slug}`}
              key={p.slug}
              data-testid={HOME.fieldNotesCard(p.slug)}
              className="product-card flex flex-col group"
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={p.coverImage}
                  alt={p.title}
                  className="absolute inset-0 w-full h-full object-cover editorial-img transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 bg-[var(--brand-forest)] text-[var(--brand-parchment)] text-[10px] tracking-[0.22em] uppercase px-2.5 py-1">
                  {p.category}
                </span>
              </div>
              <div className="p-6 flex flex-col grow">
                <div className="flex items-center gap-3 text-xs uppercase tracking-[0.18em] text-[var(--brand-muted)]">
                  <span>{formatDate(p.date)}</span>
                  <span>·</span>
                  <span>{p.readMins} min read</span>
                </div>
                <h3 className="mt-3 font-display text-2xl text-[var(--brand-forest)] tracking-tight leading-snug">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm text-[var(--brand-ink)] leading-relaxed grow">
                  {p.excerpt}
                </p>
                <span className="mt-5 pt-5 border-t border-[var(--brand-stone)] text-sm font-semibold text-[var(--brand-forest)] inline-flex items-center gap-1.5">
                  Read the note <ArrowUpRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
